export default "__VITE_ASSET__Dj9hZlRQ__"